export default "__VITE_ASSET__88a8d9bf__"